import { render, staticRenderFns } from "./FugaPeople.vue?vue&type=template&id=16acc853&"
import script from "./FugaPeople.vue?vue&type=script&lang=js&"
export * from "./FugaPeople.vue?vue&type=script&lang=js&"
import style0 from "./FugaPeople.vue?vue&type=style&index=0&id=16acc853&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports